<template lang="pug">
  div#dashboard(v-cloak)
    v-layout(row wrap)

      //- ----------------------------------------
      //- 簡易計算
      //- ----------------------------------------
      v-flex.mt-1(xs12 sm6 md3 offset-md6 v-if="hasRole('user')")
        router-link(:to="{ name: 'calc' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.lime.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/estimate.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-cog
                    span 簡易重量計算

      //- ----------------------------------------
      //- 注文入力
      //- ----------------------------------------
      v-flex.mt-1(xs12 sm6 md3 v-if="hasRole('user')")
        router-link(:to="{ name: 'order_estimate' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.teal.darken-1.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/estimate.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-pencil
                    span {{$t('order.estimate')}}

      //- ----------------------------------------
      //- Fabric売上明細
      //- ----------------------------------------
      v-flex.mt-1(xs12 sm6 md3 offset-md6 v-if="hasRole('user')")
        router-link(:to="{ name: 'fabric' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.brown.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/estimate.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-search
                    span Fabric売上明細

      //- ----------------------------------------
      //- 返答待ち
      //- ----------------------------------------
      v-flex.mt-1(xs12 sm6 md3 v-if="hasRole('user')")
        router-link(:to="{ name: 'order_estimated' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.pink.darken-1.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/estimated.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-hourglass-half
                    span {{$t('order.estimated')}}

                  div.item-text-box
                    span.remain-count(:class="count.estimated > 0 ? '' : 'zero'") {{count.estimated}}
                    span.requested-remain-count(v-if="count.requested > 0") +{{count.requested}}

      //- ----------------------------------------
      //- 調整待ち
      //- ----------------------------------------
      v-flex(xs12 sm6 offset-sm6 md3 offset-md9 v-if="hasRole('user')")
        router-link(:to="{ name: 'order_settled' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.deep-purple.darken-1.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/settled.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-gavel
                    span {{$t('order.settled')}}
                  div.item-text-box
                    span.remain-count(:class="count.settled > 0 ? '' : 'zero'") {{count.settled}}

      //- ----------------------------------------
      //- 加工待ち
      //- ----------------------------------------
      v-flex(xs12 sm6 offset-sm6 md3 offset-md9 v-if="hasRole('user')")
        router-link(:to="{ name: 'order_arranged' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.amber.darken-3.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/arranged.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-cogs
                    span {{$t('order.arranged')}}
                  div.item-text-box
                    span.remain-count(:class="count.arranged > 0 ? '' : 'zero'") {{count.arranged}}

      //- ----------------------------------------
      //- 完了
      //- ----------------------------------------
      v-flex(xs12 sm6 offset-sm6 md3 offset-md9 v-if="hasRole('user')")
        router-link(:to="{ name: 'order_completed' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.blue-grey.lighten-2.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/completed.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-check-circle
                    span {{$t('order.completed')}}
                  div.item-text-box
                    span.remain-count.zero {{count.completed}}

      //- ----------------------------------------
      //- 横断検索
      //- ----------------------------------------
      v-flex(xs12 sm6 offset-sm6 md3 offset-md9 v-if="hasRole('user')")
        router-link(:to="{ name: 'order_search' }" tag="div")
          v-card.dashboard-item-action(flat hover)
            v-card-text.pa-0
              v-layout.ma-0(row wrap)
                v-flex.cyan.pa-0(xs5)
                  div.img-box
                    img(src="/static/order/completed.png" height="80px")

                v-flex.pa-1(xs7)
                  p.item-title
                    v-icon(large) fa-search
                    span {{$t('order.search')}}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'dashboard',
  data () {
    return {
      count: {
        requested: 0,
        estimated: 0,
        settled: 0,
        arranged: 0,
        completed: 0
      }
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: 'request' })
      return true
    }
    this.$ajax.get('dashboard/dat').then(response => {
      this.count = response.data
    })
  },
  computed: {
    ...mapGetters('common/account', ['hasRole', 'isAuthenticated'])
  },
  methods: {}
}
</script>

<style scoped lang="stylus">
#dashboard {
  min-height: calc(100vh - 56px - 30px);
  overflow-y: hidden;
  background-image: url('/static/bg.png');
  background-color: #11161C;
  background-size: 100%;
}

.dashboard-item-action {
  border-radius: 0;
  margin-bottom: 6px;
  margin-left: 3px;
  margin-right: 3px;

  &:hover {
    margin-bottom: 3px;
    border-bottom: 3px solid cyan;
  }

  .img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
  }

  .item-title {
    font-size: 1.4rem;
    text-align: center;
    margin-top: 8px;

    span {
      padding: 0 0.5rem;
      vertical-align: bottom;
    }
  }

  .item-text-box {
    display: flex;
    justify-content: center;
    align-items: center;

    .zero {
      color: grey;
      opacity: 0.6;
    }

    .remain-count {
      font-size: 3rem;
    }

    .requested-remain-count {
      font-size: 3rem;
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Dashboard/index.vue